module.exports = __webpack_public_path__ + "img/pic1.b0ae4eb5.png";